module.exports = __webpack_public_path__ + "static/media/wardah_brand_banner.a138bff2.jpg";